import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ExchangeStatus = 'NOT_CONNECTED' | 'CONNECTED' | 'SYNCING' | 'ERROR';

export interface ExchangeState {
  exchanges: Record<string, ExchangeStatus>;
  setConnected: (exchangeId: string) => void;
  setSyncing: (exchangeId: string) => void;
  setError: (exchangeId: string) => void;
  setDisconnected: (exchangeId: string) => void;
  removeExchange: (exchangeId: string) => void;
  clearAllExchanges: () => void;
}

export const useExchangeStore = create<ExchangeState>()(
  persist(
    (set: any, get: any) => ({
      exchanges: {},
      setConnected: (exchangeId: string) => set((state: ExchangeState) => ({
        exchanges: { ...state.exchanges, [exchangeId]: 'CONNECTED' }
      })),
      setSyncing: (exchangeId: string) => set((state: ExchangeState) => ({
        exchanges: { ...state.exchanges, [exchangeId]: 'SYNCING' }
      })),
      setError: (exchangeId: string) => set((state: ExchangeState) => ({
        exchanges: { ...state.exchanges, [exchangeId]: 'ERROR' }
      })),
      setDisconnected: (exchangeId: string) => set((state: ExchangeState) => ({
        exchanges: { ...state.exchanges, [exchangeId]: 'NOT_CONNECTED' }
      })),
      removeExchange: (exchangeId: string) => set((state: ExchangeState) => {
        const newExchanges = { ...state.exchanges };
        delete newExchanges[exchangeId];
        return { exchanges: newExchanges };
      }),
      clearAllExchanges: () => set(() => ({ exchanges: {} })),
    }),
    {
      name: 'exchange-store',
      storage: {
        getItem: (name: string) => {
          const value = localStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name: string, value: any) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name: string) => localStorage.removeItem(name)
      }
    }
  )
);
